// Do NOT add "use client" to this file
import { DEPRECATED_backwardsCompatibleValues } from "@faire/retailer-visitor-shared/views/search-v2/util/DEPRECATED_backwardsCompatibleValues";
import upperFirst from "lodash/upperFirst";
export var getHelmetData = function(query, isFromDiscoverUrl, strictLocalize, brandReviews) {
    var suppliersSearchTerms = /(wholesalers|wholesaler|wholesaling)[^\s]*/gi;
    var header, title, description;
    /**
     * We want to handle special supplier-aimed search terms such as "coffee wholesalers" or
     * "Toronto wholesaling." This requires a subtle change from the standard title, header,
     * and description; namely, by removing the hard-coded "Wholesale" text right before the
     * query. This case is intended to handle that.
     */ if (query.match(suppliersSearchTerms)) {
        var queryString = query.replace(suppliersSearchTerms, "$& products");
        if (isFromDiscoverUrl) {
            header = strictLocalize({
                id: "t15YiX",
                defaultMessage: [
                    {
                        type: 1,
                        value: "queryString"
                    },
                    {
                        type: 0,
                        value: " for your store"
                    }
                ]
            }, DEPRECATED_backwardsCompatibleValues({
                queryString: queryString
            }));
        } else {
            header = queryString;
        }
        if (isFromDiscoverUrl) {
            title = strictLocalize({
                id: "XBHVTL",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Wholesale "
                    },
                    {
                        type: 1,
                        value: "queryString"
                    },
                    {
                        type: 0,
                        value: " for your store"
                    }
                ]
            }, DEPRECATED_backwardsCompatibleValues({
                queryString: queryString
            }));
        } else {
            title = strictLocalize({
                id: "BQPTUK",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Purchase "
                    },
                    {
                        type: 1,
                        value: "queryString"
                    },
                    {
                        type: 0,
                        value: ". Free Returns & Net 60 Terms on Faire"
                    }
                ]
            }, DEPRECATED_backwardsCompatibleValues({
                queryString: queryString
            }));
        }
        var baseDescription = strictLocalize({
            id: "BPrk+L",
            defaultMessage: [
                {
                    type: 0,
                    value: "Shop "
                },
                {
                    type: 1,
                    value: "queryString"
                },
                {
                    type: 0,
                    value: " and more. Stock up on unique brands and products, with free returns and low order minimums."
                }
            ]
        }, DEPRECATED_backwardsCompatibleValues({
            queryString: queryString
        }));
        description = getUpdatedMetaDescription(isFromDiscoverUrl, brandReviews, baseDescription);
    } else {
        // remove the word wholesale (and variants) from title
        var queryString1 = query.replace(/(wholesale|whole sale|whole-sale)/gi, "").trim();
        if (isFromDiscoverUrl) {
            header = strictLocalize({
                id: "TWmlrv",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Wholesale "
                    },
                    {
                        type: 1,
                        value: "queryString"
                    },
                    {
                        type: 0,
                        value: " for your store"
                    }
                ]
            }, DEPRECATED_backwardsCompatibleValues({
                queryString: queryString1
            }));
        } else {
            header = strictLocalize({
                id: "lLAhkk",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Wholesale "
                    },
                    {
                        type: 1,
                        value: "queryString"
                    }
                ]
            }, DEPRECATED_backwardsCompatibleValues({
                queryString: queryString1
            }));
        }
        if (isFromDiscoverUrl) {
            title = strictLocalize({
                id: "XBHVTL",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Wholesale "
                    },
                    {
                        type: 1,
                        value: "queryString"
                    },
                    {
                        type: 0,
                        value: " for your store"
                    }
                ]
            }, DEPRECATED_backwardsCompatibleValues({
                queryString: queryString1
            }));
        } else {
            title = strictLocalize({
                id: "JzNt9u",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Purchase Wholesale "
                    },
                    {
                        type: 1,
                        value: "queryString"
                    },
                    {
                        type: 0,
                        value: ". Free Returns & Net 60 Terms on Faire"
                    }
                ]
            }, DEPRECATED_backwardsCompatibleValues({
                queryString: queryString1
            }));
        }
        var baseDescription1 = strictLocalize({
            id: "SCHVFZ",
            defaultMessage: [
                {
                    type: 0,
                    value: "Shop wholesale "
                },
                {
                    type: 1,
                    value: "queryString"
                },
                {
                    type: 0,
                    value: " and more. Stock up on unique brands and products, with free returns and low order minimums."
                }
            ]
        }, DEPRECATED_backwardsCompatibleValues({
            queryString: queryString1
        }));
        description = getUpdatedMetaDescription(isFromDiscoverUrl, brandReviews, baseDescription1);
    }
    // Use lodash upperFirst instead of capitalize because the latter converts the rest of
    // the string to lower case. Thus, the French 'B2B' will become 'b2b' which is undesired.
    return {
        title: upperFirst(title),
        description: upperFirst(description),
        header: upperFirst(header)
    };
};
var getUpdatedMetaDescription = function(isFromDiscoverUrl, brandReviews, baseDescription) {
    if (isFromDiscoverUrl) {
        var review = brandReviews === null || brandReviews === void 0 ? void 0 : brandReviews.sort(reviewSort)[0];
        if ((review === null || review === void 0 ? void 0 : review.review_comment) !== undefined) {
            return review.review_comment;
        } else {
            return baseDescription;
        }
    } else {
        return baseDescription;
    }
};
var reviewSort = function(a, b) {
    var _a_review_comment, _b_review_comment;
    var _a_review_comment_length, _b_review_comment_length;
    var lengthDifference = Math.abs(((_a_review_comment_length = (_a_review_comment = a.review_comment) === null || _a_review_comment === void 0 ? void 0 : _a_review_comment.length) !== null && _a_review_comment_length !== void 0 ? _a_review_comment_length : Number.MAX_VALUE) - 160) - Math.abs(((_b_review_comment_length = (_b_review_comment = b.review_comment) === null || _b_review_comment === void 0 ? void 0 : _b_review_comment.length) !== null && _b_review_comment_length !== void 0 ? _b_review_comment_length : Number.MAX_VALUE) - 160);
    if (lengthDifference === 0) {
        var _b_average_rating, _a_average_rating;
        return ((_b_average_rating = b.average_rating) !== null && _b_average_rating !== void 0 ? _b_average_rating : 0) - ((_a_average_rating = a.average_rating) !== null && _a_average_rating !== void 0 ? _a_average_rating : 0);
    } else {
        return lengthDifference;
    }
};
